<template>
  <div class="tw-w-full tw-space-y-2">
    <div class="tw-justify-between tw-flex tw-font-normal tw-uppercase">
      <span>{{ text }}</span>
      <span>{{ percentage }}%</span>
    </div>
    <div
      :class="[
        Classes.RATING_BAR,
        'tw-flex tw-h-1.5 tw-bg-white tw-rounded-md tw-overflow-hidden',
      ]"
    >
      <span
        :style="{ width: `${percentage}%` }"
        class="game-primary-button-color"
      >
        &nbsp;
      </span>
    </div>
  </div>
</template>

<script>
import Classes from '@shared/js/config/css.js'
export default {
  props: {
    percentage: {
      type: Number,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
  setup() {
    return { Classes }
  },
}
</script>
